'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_BOT_NAME = exports.DEFAULT_BOT_NAME = 'HubBot';

var PUBNUB_KEY = exports.PUBNUB_KEY = '@@pubNub';

var STUBBED_CHANNEL = exports.STUBBED_CHANNEL = 'STUBBED_CHANNEL';

var PRIVATE_CHANNEL = exports.PRIVATE_CHANNEL = 'private';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/constants/strings.js
// module id = 240
// module chunks = 2 3